"use client";

import { Button } from "@/components/ui";

import { useNavigateHome } from "@/hooks/use-navigate-home";

export default function ModuleNotEnabled() {
  const goHome = useNavigateHome();

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <div className="text-center">
        <h1 className="text-h1 text-foreground">Module Not Enabled</h1>
        <p className="mt-2 text-foreground-secondary">
          This feature is not enabled for your clinic. Please contact your
          administrator if you need access.
        </p>
      </div>
      <Button onClick={goHome} variant="secondary">
        Go to Home
      </Button>
    </div>
  );
}
